import CityPageTemplate from "@/pages/city-template/CityPageTemplate";
import { madisonALConfig } from "./data";

export default function MadisonALPage() {
  return <CityPageTemplate config={madisonALConfig} />;
}